import { useState } from 'react'

import { EMPTY_STRING } from '../../../constants/common'
import { useKeyboard } from '../../../hooks'
import { isEventKeyEnter, preventDefault } from '../../../utils/events'
import { BUTTON_HEIGHT_32 } from '../../Button'
import { InputField } from '../../Input'

import * as styles from './PdfViewerPageInput.module.css'

function PdfViewerPageInput({
  activePage,
  className = styles.PdfViewerPageInput,
  disabled,
  totalPages,
  onChange,
}) {
  const [value, setValue] = useState(activePage ?? EMPTY_STRING)
  const [prevActivePage, setPrevActivePage] = useState(activePage)

  // the externally controlled active page is mirrored into the input during render
  if (activePage !== prevActivePage) {
    setPrevActivePage(activePage)

    if (value !== activePage) {
      setValue(activePage)
    }
  }

  function handleChange(e) {
    setValue(e.target.value)
  }

  function handleKeyDown(e) {
    if (isEventKeyEnter(e)) {
      preventDefault(e)
    }
  }

  function handleSubmit() {
    const numberValue = parseInt(value)
    const nextPage =
      Number.isFinite(numberValue) && value > 0 && value <= totalPages
        ? numberValue
        : null

    if (nextPage !== null && nextPage !== activePage) {
      onChange(nextPage)
    }
  }

  useKeyboard(handleSubmit)

  return (
    <div className={className}>
      <InputField
        className={styles.inputField}
        disabled={disabled}
        height={BUTTON_HEIGHT_32}
        inputProps={{ className: styles.input, onKeyDown: handleKeyDown }}
        value={value}
        wrapperClassName={styles.inputWrapper}
        onBlur={handleSubmit}
        onChange={handleChange}
      />
      <span>/</span>
      <span>{totalPages}</span>
    </div>
  )
}

export default PdfViewerPageInput
